import { Footer } from "./Footer";
import { Middle } from "./Middle";
import { Navbar } from "./Navbar";

export function Home() {
    return (
        <>
            <Middle />
        </>
    );
}
